import {useCallback} from 'react';
import {overviewSearchTextUpdated} from 'services/settings';
import {useAppDispatch} from 'store/hooks';

export const useSetTaskSearchText = () => {
  const dispatch = useAppDispatch();

  return useCallback(
    (searchText: string) => {
      dispatch(overviewSearchTextUpdated(searchText));
    },
    [dispatch],
  );
};
